export default __webpack_public_path__ + "static/media/AvenirNextW04-Bold.9ae89c05.ttf";